import AgAccountManages from '@/pages/accountManage/agAccountManages'

export default [
  {
    path: '/agAccountManages',
    name: 'AgAccountManages',
    component: AgAccountManages,
    meta: { name: '账户管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/accountManage/agAccountManages.js